module.exports = __webpack_public_path__ + "img/solucion vaginal.2f81f978.png";